/**
 * Bar Chart - scroll-triggered fill animation.
 *
 * Reads --bar-value from the row's inline style and
 * sets it on the .k-bar-chart__fill once the chart
 * enters the viewport (IntersectionObserver).
 *
 * Respects prefers-reduced-motion: animates immediately
 * without waiting for scroll if motion is reduced.
 */
(function (Drupal, once) {
  Drupal.behaviors.kBarChart = {
    attach(context) {
      const prefersReduced =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      once("k-bar-chart", "[data-k-bar-chart]", context).forEach((chart) => {
        const rows = chart.querySelectorAll(".k-bar-chart__row");

        const animate = () => {
          rows.forEach((row) => {
            const fill = row.querySelector(".k-bar-chart__fill");
            if (!fill) return;
            // --bar-value is set inline on the row element from Twig
            const target =
              row.style.getPropertyValue("--bar-value").trim() || "0%";
            // Small staggered delay per row for a cascade effect
            const index = Array.from(rows).indexOf(row);
            fill.style.transitionDelay = prefersReduced
              ? "0ms"
              : `${index * 120}ms`;
            fill.style.width = target;
          });
        };

        if (prefersReduced) {
          // Animate immediately, no scroll trigger needed
          animate();
          return;
        }

        // Scroll-triggered via IntersectionObserver
        const observer = new IntersectionObserver(
          (entries, obs) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              animate();
              obs.unobserve(entry.target); // fire once only
            });
          },
          {
            threshold: 0.25, // 25% of chart visible before triggering
          },
        );

        observer.observe(chart);
      });
    },
  };
})(Drupal, once);
